angular.module('bookingApp').filter('roomGroupingShow', function(){
    return function(input){
        var watched = [];
        var outputRooms = [];
        angular.forEach(input, function(room){
            if(watched.indexOf('group' + room.roomGroupIndex) > -1){
                room.showPaxGrouped = false;
                outputRooms.push(room);
            } else {
                room.showPaxGrouped = true;
                outputRooms.push(room);
                watched.push('group' + room.roomGroupIndex);
            }
        });
        return input;
    }
});
